import { useEffect, useState } from "react";
import { useLang } from "../i18n/LangContext";
import { api } from "../api/client";
import { Flame, BookOpen, Utensils } from "lucide-react";

export function StreakBadge() {
  const { t } = useLang();
  const [s, setS] = useState(null);

  useEffect(() => { api.get("/streak/me").then(({ data }) => setS(data.data)).catch(() => {}); }, []);
  if (!s) return null;

  const hot = s.current_streak > 0;
  return (
    <div data-testid="streak-badge" className={`rounded-2xl border p-4 flex items-center gap-4 ${hot ? "border-[#FF3B30]/40 bg-[#FF3B30]/[0.06]" : "border-white/5 bg-white/[0.02]"}`}>
      <span className={`h-12 w-12 shrink-0 rounded-xl flex items-center justify-center ${hot ? "bg-[#FF3B30]/15" : "bg-white/5"}`}>
        <Flame className={`h-6 w-6 ${hot ? "text-[#FF3B30]" : "text-slate-500"}`} strokeWidth={2.5} />
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline gap-2">
          <span data-testid="streak-current" className="font-[Outfit] text-2xl font-extrabold text-white">{s.current_streak}</span>
          <span className="text-sm text-slate-400">{t("streak.days")}</span>
          {s.badge && (
            <span data-testid="streak-badge-name" className="ml-1 rounded-full border border-amber-500/30 bg-amber-500/15 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-amber-300">
              {s.badge}
            </span>
          )}
        </div>
        <div className="text-xs text-slate-500 mt-0.5">
          {t("streak.longest")}: {s.longest_streak} · {t("streak.rule")}
        </div>
        <div className="flex gap-3 mt-2 text-[11px]">
          <span data-testid="streak-today-education" className={`inline-flex items-center gap-1 ${s.today_education_done ? "text-emerald-300" : "text-slate-500"}`}>
            <BookOpen className="h-3.5 w-3.5" /> {t("streak.education")}
          </span>
          <span data-testid="streak-today-food" className={`inline-flex items-center gap-1 ${s.today_food_done ? "text-emerald-300" : "text-slate-500"}`}>
            <Utensils className="h-3.5 w-3.5" /> {t("streak.journal")}
          </span>
        </div>
      </div>
    </div>
  );
}
